var components = {
  yiLoading: function () {
    return import(
      /* webpackChunkName: "components/yi-loading/yi-loading" */ "@/components/yi-loading/yi-loading.vue"
    )
  },
  coupon: function () {
    return import(
      /* webpackChunkName: "components/coupon/coupon" */ "@/components/coupon/coupon.vue"
    )
  },
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.couponList, function (item, index) {
    var $orig = _vm.__get_orig(item)

    var m0 = _vm.expireTime(item.expireTime)
    return {
      $orig: $orig,
      m0: m0,
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }